<template>
<div class="container">
    <label>Searching Within:</label><br/>
    <div class="row">
      <div class="col-6">
        <toggle-button v-model="searchDesc" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" @change="setType()" :height="20" :width="45"/>
        <label>Description</label>
      </div>
      <div class="col-6">
        <toggle-button v-model="searchResult" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" @change="setType()" :height="20" :width="45"/>
        <label>Result</label>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <toggle-button v-model="searchTags" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" @change="setType()" :height="20" :width="45"/>
        <label>Tags</label>
      </div>
      <div class="col-6">
        <toggle-button v-model="searchNotes" color="#2780E3" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" @change="setType()" :height="20" :width="45"/>
        <label>Notes</label>
      </div>
    </div>
    
    <div class="form">
      <input type="text" v-model="searchTerm" class="form-control col-12" ref="searchInput" />
    </div>
  

  <ul class="list-group mt-2" v-if="!noWorkouts">
    <li class="list-group-item" v-for="result in searchResults" :key="result.item.id" @click.prevent="goToWorkout(result.item.id)" v-if="result.score < 1 && result.matches.length > 0">
      <icon v-if="result.item.pr" class="text-warning" name="star"></icon>
      <span class="badge badge-pill" :class="[result.item.workoutType == 'metcon' ? 'badge-primary' : result.item.workoutType == 'lift' ? 'badge-secondary' :  'badge-info']">{{result.item.workoutType}}</span> 
      {{format(result.item.date, 'MM/DD/YYYY')}}
      <div v-if="result.item.liftType" class="workoutDesc">Lift: {{result.item.liftType}} - <span v-html="result.item.highlightedText"></span></div>
      <div v-else-if="result.item.isNamedWod" class="workoutDesc">"{{result.item.namedWod.name}}" - <span v-html="result.item.highlightedText"></span></div>
      <div v-else class="workoutDesc"><span v-html="result.item.highlightedText"></span></div>
      <div class="workoutResult"><strong>Result:</strong> {{result.item.result}} <span v-if="result.item.rx" class="badge badge-pill badge-dark">Rx</span></div>
    </li>
  </ul>

  <div class="card mt-2" v-if="noWorkouts">
    <div class="card-body">
      <h4 class="card-title" style="text-align:center;"><icon name="hand-o-up" scale="2"></icon> Start Searching...</h4>
    </div>
  </div>

  <div class="row">
    &nbsp;
  </div>
</div>


</template>

<script>
//import firebase from 'firebase'
import format from 'date-fns/format'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'

//import Workout from '@/workoutData.js'

export default {
  name: 'search',
  components: {
  },
  data () {
    return {
      searchDesc: true,
      searchResult: false,
      searchTags: false,
      searchNotes: false,
      format: format,
      distanceInWordsToNow: distanceInWordsToNow,
      foundWorkouts: [],
      searchTerm: "",
      searchOptions: {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: [
          "description",
          "namedWod.name",
          "namedWod.description",
          "liftType"
        ]
      },
      searchResults: []
    }
  },
  watch: {
    searchTerm () {
      if(this.searchTerm.trim() == ""){
        this.searchResults = []
      } else {
        let myThis = this
        this.$search(this.searchTerm.trim(), this.allWorkouts, this.searchOptions).then(results => {
          this.searchResults = []
          results.forEach(result => {
            if (result.matches.length > 0) {
              let text = result.matches[0].value
              let highlightedText = ""
              let regionsAr = result.matches[0].indices
              let nextUnhighlightedRegionStartingIndex = 0
              //console.log(text)
              if(!regionsAr) {
                highlightedText = text
              } else {
                regionsAr.forEach(region => {
                  highlightedText += '' +
                  text.substring(nextUnhighlightedRegionStartingIndex, region[0]) +
                  '<span class="highlight" style="text-shadow: -3px 0px 3px yellow,3px 0px 3px yellow,6px 0px 6px yellow,-6px 0px 6px yellow;">' +
                  text.substring(region[0], region[1]+1) +
                  '</span>' + ''
                  nextUnhighlightedRegionStartingIndex = region[1]+1
                })
                highlightedText += text.substring(nextUnhighlightedRegionStartingIndex)
              }
              //console.log(highlightedText)
              result.item.highlightedText = highlightedText
              myThis.searchResults.push(result)

            } else {
              myThis.searchResults.push(result)
            }
          })
        })

      }
      
    }
  },
  computed: {
    allWorkouts () {
      return this.$store.state.allWorkouts
    },
    totalWorkoutsLoaded () {
      return this.allWorkouts.length
    },
    authUser () {
      return this.$store.state.authUser
    },
    user () {
      return this.$store.state.user
    },
    noWorkouts: function () {
      return this.searchResults.length == 0
    }
  },
  created () {
    this.$store.commit('setAllWorkouts')
    this.$on('resultsFound', results => {
      this.foundWorkouts = results
    })
  },
  mounted () {
    this.$refs.searchInput.focus()
  },
  methods: {
    goToWorkout: function (id) {
      //console.log(id)
      this.$router.push({ name: 'workout', params: { id }})
    },
    setType: function() {
      this.searchResults = []
      let searchKeys = []
      if(this.searchDesc){
        searchKeys.push("description")
        searchKeys.push("namedWod.name")
        searchKeys.push("namedWod.description")
        searchKeys.push("liftType")
      }
      if(this.searchResult){
        searchKeys.push("result")
      }
      if(this.searchTags){
        searchKeys.push("tags")
      }
      if(this.searchNotes){
        searchKeys.push("notes")
      }
      this.searchOptions.keys = searchKeys
      this.searchTerm = ""
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .badge-info {
    border: 1px solid black;
    background-color: #fff;
    color: #111;
  }
  .list-group-item {
    border-radius: 0px
  }
  .list-group-item:first-child {
    border-top-left-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
    border-top-right-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
  }
 
 .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
    border-bottom-left-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
  }

span.highlight {
  color: blueviolet;
  /*
  text-shadow: 
    -3px 0px 3px yellow,
     3px 0px 3px yellow,
     6px 0px 6px yellow,
    -6px 0px 6px yellow;
  */
}

</style>


// WEBPACK FOOTER //
// src/components/search.vue